import qs from "query-string";
import { BEConfig } from "../config/env";
import { webapiGet, webapiPost } from "../webapis/core";
import ApiService from "./apiService";

export interface DeliveryDatePreviewResponse {
  deliveryType: string;
  deliveryOptions: Array<{
    key: string;
    messages: string[];
  }>;
}

class DeliveryInfoService extends ApiService {
  async getDeliveryInfo({ guest_state_id }: { guest_state_id: number }) {
    const { settingsHandle, deliveryInfo } = BEConfig.commonApi;

    const endpoint = qs.stringifyUrl(
      {
        url: `${this.getBaseUrl()}${settingsHandle}${deliveryInfo}`,
        query: {
          guest_state_id
        }
      },
      { encode: false }
    );

    const response = await webapiGet(
      this.getAccessToken(),
      endpoint,
      this.getVisitorId()
    ).request;

    return response.data;
  }

  async previewDeliveryDate(payload: {
    deliveryType: string;
    stateId: number;
    areaId: number;
  }): Promise<DeliveryDatePreviewResponse> {
    const { settingsHandle, deliveryDatePreview } = BEConfig.commonApi;
    const endpoint = `${this.getBaseUrl()}${settingsHandle}${deliveryDatePreview}`;

    const response = await webapiPost(
      this.getAccessToken(),
      endpoint,
      payload,
      this.getVisitorId()
    ).request;

    return response.data;
  }

  getBaseUrl(): string {
    const { protocol, baseURL, port, versionInfo } = BEConfig.commonApi;

    return `${protocol}${baseURL}${port}${versionInfo}`;
  }
}

const deliveryInfoService = new DeliveryInfoService();

export default deliveryInfoService;
